// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"ErrorWindow_sectionHeader__83mbS","title":"ErrorWindow_title__izdwr","description":"ErrorWindow_description__Lq7KN","icon":"ErrorWindow_icon__QBLjv"};